import React, { useEffect, useState } from 'react'

import TableList from '../../atoms/table-list/table-list'
import { requestTopInfo } from './data-store'
import { StaticImage } from 'gatsby-plugin-image'
/* import zonaV from '../../../assets/images/personajes/zona-v@2x.png' */
const total_top = 5
const Personaje = () => {
  return (
    <div className="personaje">
      <StaticImage
        src={'../../../assets/images/logo.png'}
        alt="personaje Zona V"
        className="personaje__sprite"
        height={300}
        placeholder="blurred"
      />
    </div>
  )
}

const cutTo = (text, limit = 10) => {
  return text.substring(0, limit) + (text.length > limit ? '...' : '')
}
const formatEmail = email => {
  return cutTo(email, 12)
  //return '***@' + domain
}

function TableContent({ isMobile, ready }) {
  const [list, setList] = useState([])
  useEffect(() => {
    if (!ready) {
      return
    }
    requestTopInfo().then(({ toplist }) => {
      const winnerList = [...toplist].slice(0, total_top)

      while (winnerList.length < total_top) {
        winnerList.push(null)
      }
      setList(winnerList)
    })
  }, [ready])
  return (
    <TableList
      header={isMobile ? ['Ranking'] : ['Ranking', 'Nombre', 'Correo']}
      records={list.map((user, idx) => {
        if (!user) {
          return []
        }
        let row = [
          [
            <div key="1" style={{ display: 'flex', alignItems: 'center' }}>
              <StaticImage src={'../../../assets/images/emblema-top.png'} alt={"top"+idx}  height={38} placeholder="blurred" />
              <div style={{ marginLeft: 10 }}>
                {idx + 1}
              </div>
            </div>,
          ],
          <span className="--capitalize">{cutTo(user.name, 18)}</span>,
          formatEmail(user.email),
        ]
        return isMobile
          ? [
              <>
              <StaticImage src={'../../../assets/images/emblema-top.png'} alt={"top"+idx} class='emblem'  height={38} placeholder="blurred" />
                <p>
                  <b>{idx + 1}.</b> {row[1]}
                </p>
                <p>{row[2]}</p>
              </>,
            ]
          : row
      })}
    />
  )
}
export const RightSide = ({ isMobile, ready }) => {
  return (
    <div className="f-top-section__table-content">
      <h3 className="--margin-bottom">
        ¡Las mejores {total_top} jugadoras están aquí!
      </h3>
      <TableContent isMobile={isMobile} ready={ready} />
      {/* <Personaje /> */}
    </div>
  )
}
